import { render, staticRenderFns } from "./UseOfTechnology.vue?vue&type=template&id=13a9b4ae&"
import script from "./UseOfTechnology.vue?vue&type=script&lang=ts&"
export * from "./UseOfTechnology.vue?vue&type=script&lang=ts&"
import style0 from "./UseOfTechnology.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports